<!---->
<!---->
<!---->
<app-label-input [hasTooltip]="hasTooltip()" [required]="required()" [textTooltip]="textTooltip()"
   [textLabel]="textLabel()" />
<!---->
<!---->
<!---->
<!--DISABLED-->
@if(disabled()) {
<!---->
<!---->
<!---->
<div class="d-flex align-items-start gap-10">
   <!---->
   <!---->
   <!---->
   <mat-form-field class="w-100" appearance="outline">
      <input matInput [type]="hidePassword ? 'password' : 'text'" [value]="value()" disabled />
      <!---->
      <!---->
      <!---->
      @if(form.enabled) {
      <i-tabler matSuffix [name]="hidePassword ? 'eye-off' : 'eye'" class="icon-20 stroke-1"
         (click)="hidePassword = !hidePassword" />
      }
   </mat-form-field>
   <!---->
   <!---->
   <!---->
   @if(hasButtonCopy()) {
   <span matTooltip=" {{ 'CopyInputValue' | translate }}"
      class="rounded icon-40 f-s-12 d-flex align-items-center justify-content-center cursor-pointer b-1"
      (click)="onCopy()">
      <i-tabler name="copy" class="icon-20 stroke-1" />
   </span>
   }
   <!---->
   <!---->
   <!---->
</div>
<!---->
<!---->
<!---->
} @else {
<!---->
<!---->
<!---->
<div class="d-flex align-items-start gap-10">
   <!---->
   <!---->
   <!---->
   <mat-form-field class="w-100" appearance="outline">
      <!---->
      <!---->
      <!---->
      <input matInput [type]="hidePassword ? 'password' : 'text'" [formControlName]="nameControl()!"
         placeholder="{{ placeholder() | translate }}" [maxlength]="maxlength()" (blur)="onChangeBlur()"
         autocomplete="new-password" autocorrect="off" autocapitalize="off" spellcheck="false" />
      <!---->
      <!---->
      <!---->
      @if(f[nameControl()!].enabled) {
      <i-tabler matSuffix [name]="hidePassword ? 'eye-off' : 'eye'" class="icon-20 stroke-1"
         (click)="hidePassword = !hidePassword" />
      }
      <!---->
      <!---->
      <!---->
      @if(hasErrorMessage()) {
      <mat-error class="f-s-9">
         {{ getErrorMessage() }}
      </mat-error>
      }
      <!---->
      <!---->
      <!---->
   </mat-form-field>
   <!---->
   <!---->
   <!---->
   @if(hasButtonCopy()) {
   <span matTooltip=" {{ 'CopyInputValue' | translate }}"
      class="rounded icon-40 f-s-12 d-flex align-items-center justify-content-center cursor-pointer b-1"
      (click)="onCopy()">
      <i-tabler name="copy" class="icon-20 stroke-1" />
   </span>
   }
   <!---->
   <!---->
   <!---->
</div>
<!---->
<!---->
<!---->
}
